import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { useFormState } from 'react-hook-form';

interface FormFieldsetProps extends ComponentPropsWithoutRef<'fieldset'> {
  children: ReactNode;
}
const FormFieldset = ({ children, disabled, ...props }: FormFieldsetProps) => {
  const { isSubmitting } = useFormState();
  return (
    <fieldset disabled={isSubmitting || disabled} {...props}>
      {children}
    </fieldset>
  );
};

export default FormFieldset;
